import { createAction, props } from '@ngrx/store';
import { Country } from '../Clubs/clubs.model';
import { Club, Member } from './member.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records member'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records member success', 
    props<{ listData: Member[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records member failure', 
    props<{ error: string }>()
);

//Fetch Club Speific Members
export const fetchSpecificData = createAction(
    '[Data] fetch specific records member',
    props<{ clubId: number }>()
);

export const fetchSpecificDataSuccess = createAction(
    '[Data] fetch specific records member success', 
    props<{ listData: Member[], total: number }>()
);

export const fetchSpecificDataFail = createAction(
    '[Data] fetch specific records member failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record member',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record member success', 
    props<{ singleData: Member, memberData: {countryList: Country[], clubs: Club[] }}>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record member failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state member',
);